import { Component, Input, OnChanges, OnInit, ViewChild, OnDestroy, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { UtilsService } from 'src/app/inventory/purchases/utility/utils.service';
import { AddYearPipe } from '../../../../shared/pipes/add-year.pipe';
import { takeUntil, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { MergeBill } from '../../models/mergebill.modal';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { ImportserialService } from '../../services/importserial.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IPostingPeriodDetails } from '../posting-period-selector/models/posting-period.model';
import { UtilityService } from 'src/app/inventory/sales-order/utils/utility.service';

@Component({
  selector: 'app-mergebill',
  templateUrl: './mergebill.component.html',
  styleUrls: ['./mergebill.component.scss']
})
export class MergebillComponent implements OnChanges, OnInit, OnDestroy {

  @Input() allLocationsDD = [];
  @Input() itemReceiptTemplate = null;
  @Input() allDiscounts = [];
  @Input() saveBillMerge: boolean = false;
  @Input() baseCurrency;
  @Input() orgCurrency = [];
  @Output() mergeBill = new EventEmitter;
  selectedVendor: any = null;
  allVendorsDD = [];
  selectedLocation: any = null;
  isBillLocationSettingEnabled: boolean = false;
  reCalculateNotEnabled: boolean = false;
  irList = [];
  orderTotal: number = 0;
  shippingAmount: number = 0;
  discountAmount: number = 0;
  subTotal: number = 0;
  discount: number = 0;
  length: number = 0;
  selectedValueOption = null;
  displayItemReceiptList: boolean = false;
  selectedIRList = [];
  /**postingperiod**/
  currentPostingPeriodInfo!: IPostingPeriodDetails;
  updatedPostingPeriodInfo!: IPostingPeriodDetails;
  isAllowPostingPeriod: boolean = false;
  postingDate: any;
  irListTB: MergeBill[] = [];
  @ViewChild('editCurrency') overlayPanel: OverlayPanel;

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(public utilService: UtilsService, private addYearPipe: AddYearPipe, private appMainService: AppMainService,private utilityService: UtilityService,
    private purchaseService: PurchasesService, private app: AppMainComponent, private importService: ImportserialService) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.loadVendors();
    this.getIsetting();
    if (changes.allDiscounts?.currentValue) {
      this.selectedValueOption = null;
    }
    if (changes.allLocationsDD?.currentValue) {
      this.selectedLocation = this.allLocationsDD?.find(loc => loc.isDefault);
    }
    if (changes.saveBillMerge?.currentValue) {
      this.mergeItemReceiptBill();
    }
  }

  ngOnInit(): void {
    this.postingDate = this.app._showDateTimeWithZone(new Date())
    this.importService.getDecimalValue().subscribe(value => {
      if (value) {
        this.length = value;
      }
    })
  }

  findsum(list, addDiscount?) {
    this.subTotal = 0;
    this.orderTotal = 0;
    if (list?.length > 0) {
      for (let prd of this.irList) {
        this.subTotal = Number(this.subTotal) + Number(prd.netAmount);
      }
      if (addDiscount === false) {
        this.discountAmount = this.selectedValueOption?.discountValue || 0;
      }
      if (this.selectedValueOption?.type?.name == 'Percentage') {
        this.discount = Number(this.subTotal * (this.discountAmount / 100));
      } else if (this.selectedValueOption?.type?.name == 'Amount') {
        this.discount = Number(this.discountAmount);
      }
      this.orderTotal = Number((this.subTotal + (this.subTotal > 0 ? Number(this.shippingAmount) : 0)) - this.discount);
    }
  }

  loadVendors() {
    this.appMainService.isHideSpinner('vendor');
    this.purchaseService.getVendorListByPO(true).subscribe(vendor => {
      this.allVendorsDD = vendor?.map(vd => ({
        ...vd,
        currencyUnit: { code: vd.currencyCode }
      })).filter(vendor => vendor.isActive);
      this.appMainService.isHideSpinner('vendor');
    })
  }

  getItemReceiptList() {
    this.purchaseService.getRPOListByVendor(this.selectedVendor?.id, this.selectedLocation?.id ?? 0)
      .pipe(takeUntil(this.ngUnsubscribe$),
        map((data: MergeBill[]) => {
          // Modify the value in each object of the array
          return data.map(obj => {
            // Modify obj as needed
            obj.rpoDate = this.app._showDateTimeWithZone(obj.rpoDate);
            return obj;
          });
        })
      ).subscribe((data: MergeBill[]) => {
        this.irListTB = data;
        this.displayItemReceiptList = true;
      });
  }
  getIsetting() {
    this.appMainService.isShowSpinner("loadISettings");
    const iSettings = this.utilityService.getISettings();
    this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
    this.appMainService.isHideSpinner("loadISettings");
}
  saveIRList() {
    this.irList = this.selectedIRList?.map(vd => {
      const alreadyAdded = this.irList?.some(prd => prd.receivedPurchaseOrderId === vd.receivedPurchaseOrderId);
      return alreadyAdded
        ? vd // If already exists, return as is
        : { 
            ...vd, 
            netAmount: Number(vd.netAmount) * Number(vd.exchangeRate) 
          };
    });
    this.findsum(this.irList);
    this.displayItemReceiptList = false;
  }

  addIRdata() {
    this.selectedIRList = JSON.parse(JSON.stringify(this.irList));
    this.displayItemReceiptList = true;
  }

  setRPO() {
    return this.irList?.map(obj => {
      obj.id = 0;
      obj.billOrderId = 0;
      obj.statusId = 1;
      obj.createdSource = this.app.userIP;
      obj.updatedSource = this.app.userIP;
      obj.createdBy = this.app.userId;
      obj.updatedBy = this.app.userId;
      obj.createdDate = this.app._saveDateTimeWithZone(new Date());
      obj.updatedDate = this.app._saveDateTimeWithZone(new Date());
      return obj;
    });
  }

  mergeItemReceiptBill() {
    const req = {
      id: 0,
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.userId,
      updatedBy: this.app.userId,
      createdDate: this.app._saveDateTimeWithZone(new Date()),
      updatedDate: this.app._saveDateTimeWithZone(new Date()),
      number: '',
      name: '',
      description: '',
      organizationId: this.app.companyId,
      userId: 0,
      purchaseOrderId: 0,
      receivedPurchaseOrderId: 0,
      billDate: this.app._saveDateTimeWithZone(new Date()),
      warehouseId: this.selectedLocation?.id,
      contactId: null,
      shippingAddressId: 0,
      totalAmount: this.subTotal,
      currencyUnitId: this.selectedVendor?.currencyId,
      exchangeRate: this.vendorExchangeRate,
      discountTypeId: this.selectedValueOption?.discountBy ?? 0,
      discountType: null,
      discountId: (this.discount > 0 && this.selectedValueOption) ? this.selectedValueOption?.id : 0,
      discountName: (this.discount > 0 ? this.allDiscounts?.find(discount => discount.discountBy === this.selectedValueOption?.id)?.name : ''),
      discountAmount: this.discount,
      discountFinancialId: (this.discount > 0 ? this.allDiscounts?.find(discount => discount.discountBy === this.selectedValueOption?.id)?.incomeAccount : 0),
      shippingChargeAmount: 0,
      shippingFinancialId: 0,
      taxId: 0,
      taxTypeId: 0,
      taxAmount: 0,
      otherChargeAmount: 0,
      netAmount: this.orderTotal,
      totalExpenseAmount: 0,
      billAmount: this.orderTotal,
      purchaseOrderStageId: 0,
      purchaseOrderStage: '',
      paymentTermId: 0,
      paymentMethodId: 0,
      shippingTermId: 0,
      shippingMethodId: 0,
      statusId: 1,
      isValid: true,
      validFromDate: new Date().toISOString(),
      validToDate: this.addYearPipe.transform(new Date()),
      billOrderProducts: [],
      billOrderNotes: [],
      billOrderExpense: [],
      billItemReceipt: this.setRPO(),
      vendorBusinessName: this.selectedVendor?.name,
      receivedPurchaseOrderStatus: '',
      createdByUser: this.app.user.userName,
      isConverted: false,
      vendorId: this.selectedVendor?.id,
      dueDate: null,
      configJson: null,
      referenceNo: null,
      postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(new Date()),
      postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth :  (new Date().getMonth() + 1),
      postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (new Date().getFullYear())
    }
    this.purchaseService.mergeBill(req).then(() => {
      this.mergeBill.emit('success');
    })
      .catch(() => {
        this.mergeBill.emit('error');
      });
  }

  get vendorExchangeRate() {
    return (this.orgCurrency?.find(cr => cr.currencyId == this.selectedVendor?.currencyId)?.exchangeRate);
  }

  showEditExchangeRate(event) {
    this.overlayPanel.toggle(event);
    this.reCalculateNotEnabled = false;
  }

  closeCurrencyDialog(value) {
    if (!value.formData) return; // Ensure value is defined
    const { defaultRateEnabled, enableRecalculateItemRate, exchangeRate } = value.formData;

    if (!defaultRateEnabled && enableRecalculateItemRate) {
      const vendorCurrency = this.orgCurrency?.find(cr => cr.currencyId === this.selectedVendor?.currencyId);
      if (vendorCurrency) {
        vendorCurrency.exchangeRate = exchangeRate;
      }
      this.reCalculatePrices(value);
    } else if (defaultRateEnabled) {
      const vendorCurrency = this.orgCurrency?.find(cr => cr.currencyId === this.selectedVendor?.currencyId);
      if (vendorCurrency) {
          vendorCurrency.exchangeRate = exchangeRate;
      }

      if (enableRecalculateItemRate) {
        this.reCalculatePrices(value);
      } 
    }
    this.overlayPanel.hide();
  }

  reCalculatePrices(value) {
    this.irList?.map(prd => {
      prd.netAmount = Number(prd.netAmount * this.vendorExchangeRate) / Number(value.previousExchangeRate);
    })
    this.findsum(this.irList);
  }

  onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
    this.updatedPostingPeriodInfo = postingInfo;
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }

}
